/**
 * pitchTypes.js — Single source of truth for MLB pitch type codes,
 * full names, and brand colors used across The Cycle analytics UI.
 *
 * All components should import from here rather than defining their own maps.
 */

// ─── Full pitch names keyed by Statcast pitch code ───────────────────────────
export const PITCH_NAMES = {
  FF: 'Four-Seam Fastball',
  FA: 'Fastball',
  SI: 'Sinker',
  FC: 'Cutter',
  SL: 'Slider',
  ST: 'Sweeper',
  CU: 'Curveball',
  KC: 'Knuckle Curve',
  CH: 'Changeup',
  FS: 'Splitter',
  FO: 'Forkball',
  KN: 'Knuckleball',
  SV: 'Slurve',
  CS: 'Slow Curve',
  EP: 'Eephus',
  SC: 'Screwball',
  UN: 'Unknown',
};

// ─── Colors ──────────────────────────────────────────────────────────────────
export const PITCH_COLORS = {
  FF: '#e74c3c',
  FA: '#d63031',
  SI: '#e67e22',
  FC: '#f39c12',
  SL: '#9b59b6',
  ST: '#e84393',
  CU: '#2ecc71',
  KC: '#27ae60',
  CH: '#3498db',
  FS: '#1abc9c',
  FO: '#fdcb6e',
  KN: '#95a5a6',
  SV: '#6c5ce7',
  CS: '#00b894',
  EP: '#7f8c8d',
  SC: '#d35400',
  UN: '#636e72',
};

// ─── Helper ──────────────────────────────────────────────────────────────────
/** Returns the full pitch name for a code, falling back to the raw code. */
export const getPitchName = (code) => PITCH_NAMES[code] || code || '—';
